export default "__VITE_ASSET__48354585__"